import { jsx as _jsx } from "react/jsx-runtime";
import { CardFooterLink, CardFooterLinks } from '@coolblue-development/freddy';
import { Fragment } from 'react';
import { getPropertyFromLink } from '../../utils/index.js';
const EntranceCardFooterLinks = ({ entrance }) => {
    var _a;
    return (_jsx(CardFooterLinks, { children: (_a = entrance.links) === null || _a === void 0 ? void 0 : _a.map((link, index) => (_jsx(Fragment, { children: link && (_jsx(CardFooterLink, { href: getPropertyFromLink('absoluteUrl', link), children: getPropertyFromLink('title', link) })) }, `sublink-${index}`))) }));
};
export default EntranceCardFooterLinks;
//# sourceMappingURL=EntranceCardFooterLinks.js.map